import Employee from "./Employee/Employee";
import UserManagement from "./UserManagement/UserManagement";
import Notification from "./Notification";
import UserRoles from "./UserManagement/Roles/UserRoles";
export default { Employee, UserManagement, Notification, UserRoles };
